import { useAuth0 } from '@auth0/auth0-react';
import type {CSSProperties} from 'react';

const LogoutButton: React.FC = () => {
    const { logout } = useAuth0();

    const buttonStyle: CSSProperties = {
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#dc3545',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        marginTop: '10px',
        fontWeight: 'bold',
        transition: 'background-color 0.2s'
    };

    const handleLogout = (): void => {
        logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    };

    return (
        <button
            onClick={handleLogout}
            style={buttonStyle}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
        >
            Log Out
        </button>
    );
};

export default LogoutButton;